import { Controller } from "@hotwired/stimulus"

// Displays a compact fallback when the static-map proxy cannot supply a real map.
export default class extends Controller {
  static targets = ["image", "fallback"]
  static values = { url: String }

  /** @returns {void} Load the full map. */
  connect() {
    this.abortController = new AbortController()
    this.fallbackTarget.textContent = "Loading map…"
    this.loadMap(this.abortController.signal)
  }

  /** @returns {void} Release pending requests and temporary image URLs. */
  disconnect() {
    this.abortController.abort()
    if (this.imageUrl) URL.revokeObjectURL(this.imageUrl)
  }

  /**
   * @param {AbortSignal} signal Cancels work when this card leaves the page.
   * @returns {Promise<void>} Show a real image, or retain the small fallback.
   */
  async loadMap(signal) {
    try {
      const response = await fetch(this.urlValue, { signal, credentials: "same-origin" })
      if (!response.ok || response.headers.get("X-Territory-Map-Placeholder") !== "false") {
        throw new Error("Map unavailable")
      }

      const blob = await response.blob()
      if (signal.aborted) return
      this.imageUrl = URL.createObjectURL(blob)
      this.imageTarget.src = this.imageUrl
      await this.imageTarget.decode()
      if (signal.aborted) return
      this.fallbackTarget.hidden = true
      this.imageTarget.hidden = false
    } catch (error) {
      if (signal.aborted) return
      this.imageTarget.hidden = true
      this.fallbackTarget.hidden = false
      this.fallbackTarget.textContent = "Map unavailable"
    }
  }
}
